export default __webpack_public_path__ + "static/media/aftermovie-background-desktop.cda6dd40.svg";